import { cartApiHeaders } from './cartApi';
import { cartSchedule } from './cartItem';
import { DeliveryTerms, readDeliveryAddress, saveDeliveryTerms } from './deliveryAddressStorage';
import { carrinhoValidar } from './Services';

const parseDeliveryMoney = (value: string) => {
  const text = value.trim();
  if (!text) return NaN;
  return Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text);
};

export type DeliverySelection = { endereco: string; latitude: string; longitude: string; bairro?: string;
  agendamento?: { data: string | null; hora: string | null } };
export type DeliveryQuote = DeliveryTerms & { empresaid: string; consultadoEm: string };

export function readDeliverySelection(): DeliverySelection {
  const { endereco, latitude, longitude, bairro } = readDeliveryAddress();
  return { endereco, latitude, longitude, bairro, agendamento: cartSchedule() };
}

export async function quoteStoreDelivery(empresaid: string, entrega: DeliverySelection, signal?: AbortSignal, validarHorario = false): Promise<DeliveryQuote> {
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal?.addEventListener('abort', abort);
  if (signal?.aborted) controller.abort();
  const timeout = window.setTimeout(abort, 20000);
  try {
    const response = await fetch(carrinhoValidar.url, { method: 'POST', headers: cartApiHeaders(), credentials: 'include', signal: controller.signal,
      body: JSON.stringify({ empresaid, produtos: [], entrega, somenteEntrega: true, validarHorario }) });
    const result = await response.json();
    if (controller.signal.aborted) throw new Error('Não foi possível atualizar a entrega. Tente novamente.');
    if (!response.ok) throw new Error(result.message || 'Não foi possível atualizar a entrega. Tente novamente.');
    const quote = result.entrega;
    if (quote?.empresaid !== empresaid || typeof quote.taxa !== 'string' || typeof quote.tempo !== 'string'
      || !Number.isFinite(parseDeliveryMoney(quote.taxa)) || parseDeliveryMoney(quote.taxa) < 0) {
      throw new Error('Não foi possível confirmar o frete e prazo atuais. Tente novamente.');
    }
    if (result.valid !== true || controller.signal.aborted) throw new Error('Não foi possível confirmar a entrega. Tente novamente.');
    return quote;
  } catch (failure) {
    if (controller.signal.aborted) throw new Error('Não foi possível atualizar a entrega. Tente novamente.');
    throw failure;
  } finally {
    window.clearTimeout(timeout);
    signal?.removeEventListener('abort', abort);
  }
}

export function saveDeliveryQuote(quote: DeliveryQuote) {
  saveDeliveryTerms(quote.taxa, quote.tempo);
}
